import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { media } from '../themes/theme';
import { FocusStyles } from '../../styles/FocusStyles';
import { lineClampCss } from '../../helpers/lineClampCss';
const CardHeaderText = styled.span `
  ${lineClampCss(1)}
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  font-family: ${props => props.theme.fonts.serif};
  font-size: 0.8125rem;
  line-height: 1;

  ${media.tablet `
    font-size: 0.875rem;
  `}
`;
const IconLinkOrButtonStyles = css `
  border: none;
  background: none;
  display: inline-flex;
  flex-grow: 0;
  flex-shrink: 1;
  padding: 0;
  margin-left: auto;
`;
const CardHeaderButtonInner = styled.button `
  ${IconLinkOrButtonStyles}
  ${FocusStyles}
  cursor: pointer;
`;
const CardHeaderIconRouterLink = styled(Link) `
  ${IconLinkOrButtonStyles}
  ${FocusStyles}
  cursor: pointer;
`;
const CardHeaderIconWrapper = styled.div `
  ${IconLinkOrButtonStyles}
`;
export function CardHeaderIcon(props) {
    const { title, children, icon, dataTestId: dataTestIdDeprecated, 'data-testid': dataTestId, 'data-trackingid': dataTrackingId, } = props;
    if ('to' in props) {
        const { to } = props;
        return (React.createElement(CardHeaderIconRouterLink, { "aria-label": title, to: to, "data-testid": dataTestId || dataTestIdDeprecated, "data-trackingid": dataTrackingId },
            icon,
            children && React.createElement(CardHeaderText, null, children)));
    }
    if ('onClick' in props) {
        const { onClick } = props;
        return (React.createElement(CardHeaderButtonInner, { "aria-label": title, onClick: onClick, "data-testid": dataTestId || dataTestIdDeprecated, "data-trackingid": dataTrackingId },
            icon,
            children && React.createElement(CardHeaderText, null, children)));
    }
    return (React.createElement(CardHeaderIconWrapper, { "aria-label": title, "data-testid": dataTestId || dataTestIdDeprecated, "data-trackingid": dataTrackingId },
        icon,
        children && React.createElement(CardHeaderText, null, children)));
}
const CardHeaderStyles = css `
  text-decoration: none;
  font-weight: 500;
  color: inherit;
  border: none;
  display: inline-flex;
  flex-grow: 0;
  flex-shrink: 1;
  /* Force new block context for flexbox */
  overflow: hidden;
  min-width: 1rem;
  align-items: center;
`;
const CardHeaderLinkInner = styled(Link) `
  ${CardHeaderStyles}
  ${FocusStyles}
`;
const CardHeadlineWrapper = styled.span `
  ${CardHeaderStyles}
`;
export function CardHeaderIconWithText(props) {
    const { title, 'data-trackingid': dataTrackingId, dataTestId, icon, children, } = props;
    if ('to' in props) {
        const { to } = props;
        return (React.createElement(CardHeaderLinkInner, { to: to, "aria-label": title, "data-testid": dataTestId, "data-trackingid": dataTrackingId },
            icon,
            children && React.createElement(CardHeaderText, null, children)));
    }
    return (React.createElement(CardHeadlineWrapper, { "aria-label": title, "data-testid": dataTestId, "data-trackingid": dataTrackingId },
        icon,
        children && React.createElement(CardHeaderText, null, children)));
}
export const CardHeader = styled.span `
  align-items: center;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
  height: 1.125rem;
  /* Prevent the Image from overlapping in some breakpoints */
  z-index: +1;

  ${media.tablet `
    height: 2rem; 
  `}
`;
export const CardHeaderButton = CardHeaderIcon;
export const CardHeaderLink = CardHeaderIconWithText;
